//#region import
import React, { Fragment, createContext, useContext, useEffect, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { FnAxios, FnDialog, I18n, ParseHtml } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Divider, Grid, Tooltip, Typography } from '@mui/material';
import { BtnCancel, BtnDraft, BtnEdit, BtnSend, BtnSendRequest } from 'components/Button/ButtonAll';
import ErrorIcon from '@mui/icons-material/Error';
import { FormProvider, useForm } from 'react-hook-form';
import { TextAreaItem } from 'components/Input/TextArea';
import AccordionPanel from '../components/AccordionPanel';
import { useLocation } from 'react-router';
//#endregion

const Panel5 = () => {
    const { 
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sTargetGroupMain: null,
            sTargetGroupSecondary: null,
        } as any,
    });

    useEffect(() => {
        setisEditSecretary(isModeSecretary === true ? false : isPermission);
    }, [isModeSecretary]);

    useEffect(() => {
        if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID]);

    const handleGetFormProjectID = () => {
        // DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID_Panel5, { nProjectID : nProjectID }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);
            form.setValue("sTargetGroupMain", result.objResult.sTargetGroupMain);
            form.setValue("sTargetGroupSecondary", result.objResult.sTargetGroupSecondary);
        });
    };

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        let ObjData = form.getValues(); 
        if (nModeID === EnumSaveModeProject.Submit && (ObjData.sTargetGroupMain === null || ObjData.sTargetGroupMain === "")) {
            return DialogFn.Warning("กรุณากรอกข้อมูล กลุ่มเป้าหมายหลัก");
        } 
        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPanelID: EnumProjectPanel.Panel5,
            isFastTrack: isFastTrack,

            sTargetGroupMain: ObjData.sTargetGroupMain,
            sTargetGroupSecondary: ObjData.sTargetGroupSecondary,

            sLocation: location.pathname,
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent) 
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPanel5, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        // setarrisEditPanel({nPanelID: 5, isEdit: false});
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    return (
        <AccordionPanel
            header={"5. กลุ่มเป้าหมาย"}
            isExpanded={true} 
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />     
                )      
            }
            isDisabled={nProjectID === 0}
        >
            <Grid id={"myDivPanel5"} item xs={12} md={12} container spacing={1} style={{ padding: '2%', paddingBottom: '1%', }}>
                <FormProvider {...form}>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                            <Grid item>
                                <Typography variant='h6' color={'#0000a5'}>กลุ่มเป้าหมาย</Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip placement={'right-end'} title={"กำหนดกลุ่มเป้าหมายหลักหรือรอง โดยระบุผู้เข้าร่วมกิจกรรม (เน้นผู้ได้รับผลโยชน์)"} >
                                    <ErrorIcon color='primary'/>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Divider />
                            </Grid>
                        </Grid>                                        
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                id={"sTargetGroupMain"}
                                name={"sTargetGroupMain"}
                                label={"กลุ่มเป้าหมายหลัก"}                               
                                required={true}
                                maxLength={500}
                                row={3}
                                disabled={!isPermission || isEditSecretary === false}
                            />
                        </Grid> 
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                id={"sTargetGroupSecondary"}
                                name={"sTargetGroupSecondary"}
                                label={"กลุ่มเป้าหมายรอง"}                               
                                required={false}
                                maxLength={500}
                                row={3}
                                disabled={!isPermission || isEditSecretary === false}
                            />
                        </Grid>
                        {nProjectID === 0 || nStatusID === EnumProjectStatusID.nStatusID_11 ?
                            <></>
                            :
                            (isPermission === true &&
                                (isModeSecretary !== true ?
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                            <Grid item>
                                                <BtnDraft id={"btnDraft_Panel5"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                            </Grid>
                                        }
                                        <Grid item>
                                            <BtnSendRequest id={"btnSend_Panel5"} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit),(err) => console.log("err", err))} />
                                        </Grid> 
                                    </Grid>   
                                : 
                                    (isModeSecretary === true ?
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                            {isEditSecretary === false ?
                                                <Grid item>
                                                    <BtnEdit id={"btnEdit_Panel5"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivPanel5").scrollIntoView({ behavior: "smooth" });}} />
                                                </Grid>
                                                :
                                                <>
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Panel5"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                                    </Grid>
                                                    <Grid item>
                                                        <BtnSendRequest id={"btnSend_Panel5"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit),(err) => console.log("err", err))}/>
                                                    </Grid>
                                                </>
                                            }   
                                        </Grid>
                                        : <></>
                                    )
                                )
                            )
                        }               
                    </Grid>                       
                </FormProvider>
            </Grid>
        </AccordionPanel>
    )
}
export default Panel5;
